import { render, staticRenderFns } from "./WelcomeSnackbar.vue?vue&type=template&id=0adf9914&"
import script from "./WelcomeSnackbar.vue?vue&type=script&lang=js&"
export * from "./WelcomeSnackbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports